import React, { Component } from 'react'
import { NotificationManager } from 'react-notifications'
import { Field, reduxForm, SubmissionError, reset } from 'redux-form'
import { connect } from 'react-redux'
import * as MabnaButton from '../../Button/Button'

import { appendToFormData, getErrors, flattenArray } from '../../../../helpers/utility'

import {
  FETCH_GRADES_REQUEST,
  ADD_SINGLE_STUDENT_TO_SCHOOL_REQUEST,
  FETCH_SCHOOL_STUDENTS_REQUEST,
} from '../../../../actions/actions'

const bothGenders = [{ id: 'male', name: 'پسر' }, { id: 'female', name: 'دختر' }]

const genderOptions = {
  girl: bothGenders.filter(gender => gender.id === 'female'),
  boy: bothGenders.filter(gender => gender.id === 'male'),
  both: bothGenders,
}

const genderOptionsProxy = new Proxy(genderOptions, {
  get(self, property) {
    if (property in self) return self[property]
    return self.both
  },
  set() {
    throw new Error('can not change available gender options dynamically')
  },
})

class AddSingleStudentToSchool extends Component {
  componentWillMount = () => {
    if (!this.props.grades) {
      this.props.dispatch({
        type: FETCH_GRADES_REQUEST,
      })
    }
  }

  createInputField = options => ({ input, meta: { touched, error } }) => (
    <div className="form-row">
      <input {...input} {...options} />
      {touched && error && <div className="form-error">{error}</div>}
    </div>
  )

  createSelectField = options => ({ input, meta: { touched, error }, choices }) => (
    <div className="form-row">
      <select {...input}>
        <option key={-1} value={-1}>
          {options.placeholder}
        </option>

        {choices.map(choice => (
          <option key={choice.id} value={choice.id}>
            {choice.name}
          </option>
        ))}
      </select>

      {touched && error && <div className="form-error">{error}</div>}
    </div>
  )

  onSubmit = values =>
    new Promise((resolve, reject) => {
      this.props.dispatch({
        type: ADD_SINGLE_STUDENT_TO_SCHOOL_REQUEST,
        resolve,
        reject,
        formData: appendToFormData(values),
      })
    })
      .then(data => {
        // notify parent
        this.props.onAddSuccess && this.props.onAddSuccess(data.student)

        // reset the form
        this.props.dispatch(reset('addSingleStudent'))

        // notify the user
        NotificationManager.success('دانش آموز با موفقیت افروده شد')

        // re-fetch list of students from the server
        this.props.dispatch({
          type: FETCH_SCHOOL_STUDENTS_REQUEST,
          schoolId: this.props.schoolId,
        })
      })
      .catch(err => {
        console.log(err)
        this.notifyUserWithErrors(err)
        throw new SubmissionError(err.form_errors)
      })

  notifyUserWithErrors = ({ form_errors, general_errors }) => {
    const flattenedErrors = [...flattenArray(general_errors), ...getErrors(form_errors)]

    for (const error of flattenedErrors) {
      NotificationManager.error(error)
    }
  }

  render() {
    const { handleSubmit, isOpen = true } = this.props

    if (!isOpen) {
      return <div />
    }

    return (
      <div className="school-add-single-student">
        <h3>{this.props.title || 'افزودن انفرادی دانش آموز'}</h3>

        <form onSubmit={handleSubmit(this.onSubmit)}>
          <div className="fields-wrapper">
            <Field
              name="first_name"
              component={this.createInputField({
                placeholder: 'نام',
                type: 'text',
              })}
            />

            <Field
              name="last_name"
              component={this.createInputField({
                placeholder: 'نام خانوادگی',
                type: 'text',
              })}
            />

            <Field
              name="national_number"
              component={this.createInputField({
                placeholder: 'شماره ملی',
                type: 'number',
              })}
            />

            <Field
              name="grade"
              component={this.createSelectField({
                placeholder: 'پایه تحصیلی',
              })}
              choices={this.props.allowedGrades || this.props.grades}
            />

            <Field
              name="gender"
              component={this.createSelectField({
                placeholder: 'جنسیت',
              })}
              choices={genderOptionsProxy[this.props.allowedGender]}
            />
          </div>

          <MabnaButton.Primary type="submit">
            افزودن
          </MabnaButton.Primary>
        </form>
      </div>
    )
  }
}

const validate = values => {
  const requiredMessage = 'این فیلد الزامی است'
  const errors = {}

  if (!values.first_name) {
    errors.first_name = requiredMessage
  }

  if (!values.last_name) {
    errors.last_name = requiredMessage
  }

  if (!values.national_number) {
    errors.national_number = requiredMessage
  }

  if (values.grade === -1 || values.grade === '-1') {
    errors.grade = requiredMessage
  }

  return errors
}

const formInfo = {
  form: 'addSingleStudent',
  validate,
}

const initialValues = {
  gender: -1,
  grade: -1,
}

const mapStateToProps = state => ({
  grades: state.grades,
  schoolId: state.auth.userId,
  initialValues,
})

export default connect(mapStateToProps)(reduxForm(formInfo)(AddSingleStudentToSchool))



// WEBPACK FOOTER //
// ./src/components/common/Services/ServiceStudentsSelector/AddSingleStudentToSchool.js